export default __webpack_public_path__ + "static/media/bosch.9a3b9a6f.svg";